module.exports = __webpack_public_path__ + "static/media/thumbnailPerseveranceScience.98d84667.jpg";